'use client';

import { UiNavigationProvider } from '@arcane-ai/ui/context';
import { usePathname, useRouter } from 'next/navigation';
import { useMemo, type ReactNode } from 'react';

/** Hands Next's router to the UI library (it never imports it itself). */
export default function NavigationProvider({
  children
}: {
  children: ReactNode;
}) {
  const router = useRouter();
  const pathname = usePathname() || '/';
  const value = useMemo(
    () => ({
      pathname,
      push: (href: string) => router.push(href),
      replace: (href: string) => router.replace(href),
      refresh: () => router.refresh()
    }),
    [pathname, router]
  );
  return <UiNavigationProvider value={value}>{children}</UiNavigationProvider>;
}
